# Migrating Job Posting API

The retired Job Posting API was a REST-based API that allowed integration partners to post & manage SEEK job ads on behalf of SEEK hirers.

This section guides you through the process of migrating from the Job Posting API to the SEEK API.

For more general information, see the [Job Posting use case documentation].

## SEEK API overview

The SEEK API implements a new way to interface with and consume our job posting-related products.

At a high level, the SEEK API uses:

- [GraphQL] for exposing our business objects.
- Data structures for SEEK API resources based on [HR Open Standards].
- New [object identifiers] for interfacing with our business objects.
- New [authentication] flows.

See [GraphQL in practice] for more information.

[job posting use case documentation]: /use-cases/job-posting
[object identifiers]: /graphql/seek-api-conventions#object-identifiers
[authentication]: /auth
[hr open standards]: https://www.hropenstandards.org/
[graphql]: https://graphql.org/
[graphql in practice]: /graphql/in-practice

## Migration development phases

Migrating to the SEEK API is a five-phase process:

1. [Auth](/migration-guides/job-posting-api/phase-1-auth)
2. [Object identifiers](/migration-guides/job-posting-api/phase-2-object-identifiers)
3. [Ad selection](/migration-guides/job-posting-api/phase-3-ad-selection)
4. [Managing job ads](/migration-guides/job-posting-api/phase-4-managing-job-ads)
5. [Event delivery](/migration-guides/job-posting-api/phase-5-event-delivery)

Each phase will have a set of exit criteria that will determine your readiness to move to the next phase.

Depending on your current Job Posting API integration, these phases may be tweaked and changed to facilitate any differences.
It is important to work closely with SEEK’s support team to plan and execute the migration effectively.

If you are ready to begin, start the first phase below.
